import { getUserRecentSearch } from "@/api/home";
import { saveRecentSearch } from "@/api/savedSearch";

export const recentSearchLocalSave = async ({searchURI, searchBy, isLoggedIn, value, isMenu, category, propertyCategory, propertyStatus}) => {
  let newSearch = {
    defaultSearchText: searchBy,
    flag: false,
    id: `${"/" + searchURI}`.replace('//', '/'),
    searchURI: `${"/" + searchURI}`.replace('//', '/'),
    timeStamp: (new Date()).getTime(),
    value: searchBy || value,
    category: category || "Browse All",
    propertyCategory,
    propertyStatus
  };
  if (isMenu) {
    localStorage.setItem("goBackSearch", JSON.stringify(newSearch));
    return;
  } else {
    localStorage.setItem("goBackSearch", JSON.stringify(newSearch));
  }
  try {
    let recentSearch = [];
    if (isLoggedIn) {
      const response = await saveRecentSearch({searchBy, url: `${"/" + searchURI}`.replace('//', '/'), searchURI: `${"/" + searchURI}`.replace('//', '/')});
      if (response === 'SUCCESS') {
        recentSearch = await getUserRecentSearch();
      }
    }
    var recentSearchLocal = localStorage.getItem("recentSearch");
    recentSearchLocal = recentSearchLocal && JSON.parse(recentSearchLocal);
    if (recentSearchLocal?.cookieElements) {
      if (recentSearch?.length > 0) {
        recentSearch.sort((a, b) => a.id === newSearch.id ? -1 : b.id === newSearch.id ? 1 : 0);
        if (recentSearch[0]?.id !== newSearch?.id) { recentSearch.unshift(newSearch) }
        recentSearchLocal.cookieElements = recentSearch.filter((value, index, self) => self.findIndex(v => v.id === value.id) === index).map(recent => ({...recent, defaultSearchText: recent.value}));
      } else {
        recentSearchLocal.cookieElements.unshift(newSearch);
        recentSearchLocal.cookieElements = recentSearchLocal?.cookieElements.filter((value, index, self) => self.findIndex(v => v.id === value.id) === index);
      }
      recentSearchLocal = JSON.stringify(recentSearchLocal);
      localStorage.setItem("recentSearch", recentSearchLocal);
    } else {
      recentSearchLocal = {
        "id": null,
        "value": "awsRecentSearch",
        "characterLimit": 15,
        "mobileCharacterLimit": 12,
        "showLimit": 5,
        "mobileShowLimit": 3,
        "cookieElements": recentSearch?.length > 0 ? isLoggedIn ? recentSearch : [newSearch, ...recentSearch] : [newSearch]
      }
      recentSearchLocal.cookieElements = recentSearchLocal?.cookieElements.filter((value, index, self) => self.findIndex(v => v.id === value.id) === index);
      recentSearchLocal = JSON.stringify(recentSearchLocal);
      localStorage.setItem("recentSearch", recentSearchLocal);
    }
  } catch(e) { }
}